export default class ClipView {
  constructor(clips) {
    this.clips = clips;
  }

  render() {
    const main = document.createElement('main');
    main.classList.add('main');
    const clipBlock = document.createElement('div');
    clipBlock.classList.add('information-item-container');
    clipBlock.style.display = 'none';
    const clipList = document.createElement('ul');
    clipList.classList.add('horizontal-list');
    clipList.classList.add('scroll');
    const clipController = document.createElement('div');
    clipController.classList.add('information-controler-container');
    clipController.style.display = 'none';
    clipController.classList.add('information-controler');
    const clipControllerList = document.createElement('ul');
    clipControllerList.classList.add('information-controler__list');
    clipControllerList.classList.add('horizontal-list');
    clipControllerList.innerHTML = `<li><button class="information-controler__list-item red-stylized-pageButton active-page" id="first-controller-button">1</button></li>
    <li><button class="information-controler__list-item red-stylized-pageButton" id="second-controller-button">2</button></li>
    <li><button class="information-controler__list-item red-stylized-pageButton" id="third-controller-button">3</button></li>
    <li><button class="information-controler__list-item red-stylized-pageButton" id="fourth-controller-button">4</button></li>`;
    const clipAdderBlock = document.createElement('div');
    clipAdderBlock.classList.add('information-controler__border-block');
    clipList.innerHTML = this.clips.map(clip => `${clip}`).join('');
    document.body.appendChild(main);
    main.appendChild(clipBlock);
    clipBlock.appendChild(clipList);
    main.appendChild(clipController);
    clipController.appendChild(clipControllerList);
    clipController.appendChild(clipAdderBlock);
  }

  static renderAddingClip(clipArray) {
    const clipList = document.querySelector('.scroll');
    clipList.innerHTML += clipArray.map(clip => `${clip}`).join('');
  }

  static clearClipList() {
    document.querySelector('main').remove();
  }
}
